import React, { useMemo, useState, useEffect } from "react";
import { Box, Typography, CircularProgress, Pagination } from "@mui/material";
import UserCard from "./userCard";
import { SalesRepListProps } from "./types";

const SalesRepList: React.FC<SalesRepListProps> = ({
  data,
  loading,
  searchQuery = "",
  onSalesrepClick,
  selectedSalesrepId
}) => {
  const [page, setPage] = useState<number>(1);

  const itemsPerPage = 10;

  const filteredSalesReps = useMemo(() => {
    const term = searchQuery.trim().toLowerCase();
    if (!term) return data;
    return data.filter(
      (rep) =>
        rep.name.toLowerCase().includes(term) ||
        rep.mobile.toLowerCase().includes(term) ||
        rep.id.toLowerCase().includes(term)
    );
  }, [data, searchQuery]);

  const totalPages = Math.ceil(filteredSalesReps.length / itemsPerPage);
  const paginatedSalesReps = filteredSalesReps.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  // reset page on search/data change
  useEffect(() => {
    setPage(1);
  }, [searchQuery, data]);

  // 🧩 Handle card click (View Details)
  const handleSalesrepSelect = (id: string) => {
    // setSelectedSalesrepId(id);
    onSalesrepClick?.(id);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "84%" }}>
      {/* List */}
      <Box sx={{ flex: 1, overflowY: "auto", px: 1.5, py: 1, justifyContent: "center" }}>
        {loading ? (
          <Box sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <CircularProgress
              size={24}
              sx={{ display: "block", mx: "auto", my: 2 }}
            />
          </Box>
        ) : paginatedSalesReps.length > 0 ? (
          paginatedSalesReps.map((rep) => (
            <Box
              key={rep.id}
              sx={{
                border:
                  rep.id === selectedSalesrepId
                    ? "2px solid #00a392"
                    : "1px solid #e0e0e0",
                borderRadius: 2,
                mb: 1.5,
                transition: "border-color 0.2s ease-in-out",
              }}
            >
              <UserCard
                id={rep.id}
                name={rep.name}
                mobile={rep.mobile}
                showCheckbox={false}
                bottomText="View Details"
                onBottomClick={() => handleSalesrepSelect(rep.id)}
              />
            </Box>
          ))
        ) : (

          <Box sx={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Typography sx={{ textAlign: "center", color: "#9e9e9e" }}>
              No Salesreps found
            </Typography>
          </Box>
        )}
      </Box>

      {/* Pagination */}
      {totalPages > 1 && (
        <Box
          sx={{
            position: "sticky",
            bottom: 0,
            zIndex: 2,
            borderTop: "1px solid #eee",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: 0,
            bgcolor: "white",
            gap: 1,
            py: 1
          }}
        >
          <Pagination
            count={totalPages}
            page={page}
            size="small"
            onChange={(_, value) => setPage(value)}
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
};

export default SalesRepList;
